<!-- Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. -->

<div class="button-footer-left-section">
	<ng-content select="[leftButton]"></ng-content>
</div>
<div class="button-footer-middle-section">
	<ng-content select="[middleButton]"></ng-content>
</div>
<button
	class="right-button"
	mat-raised-button
	color="primary"
	[disabled]="disabled"
	(click)="saveOrClose()"
	[attr.form]="formId ? formId : null"
	[attr.type]="formId ? 'submit' : null"
>
	{{ saveOrCloseButtonText }}
</button>
